import React, { Fragment, useCallback } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, Container } from "reactstrap"
import { Filter, DefaultColumnFilter } from "./filters"

// Define a default UI for filtering

const ManageSettingsTableContainer = ({
  columns,
  data,
  onHeaderClick,
  customPageSize,
  customPageSizeOptions,
  handleAddnewUser,
  handlePageValue,
  totalCount,
  pageindex,
  issetting,
  handleUserEditGroup,
  buttonHide,
  widthControl,
  colspanChange,
  accessGroup,
  hideAddUserbutton,
  handleEditGroup,
  hideTrackProfilebutton,
  handleTracEditGroup,
  setpageValueSet,
  handlebulkUpload,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      onHeaderClick: Function,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: pageindex,
        pageSize: customPageSize,
        hiddenColumns:
          hideAddUserbutton == false || hideTrackProfilebutton == false
            ? ["hideeditButton"]
            : [],
        // sortBy: [
        //   {
        //     desc: true,
        //   },
        // ],
        columnVisibility: { hidden: false }
      },
      manualPagination: true,
      manualSortBy: true,
      pageCount: Math.ceil(totalCount / customPageSize),
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )

  const generateSortingIndicator = column => {
    return column.sort ? <i className={column.isSortedDesc ? "bx bx-sort-down" : "bx bx-sort-up"}></i> : ""
      }

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
    handlePageValue({
      pageSize: Number(event.target.value),
      pageNumber: 0,
      noChange: true,
    })
  }
  const handlenext = data => {
    // setpageValueSet(pageIndex + 1)
    nextPage(data)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: pageIndex + 1,
    })
  }
  const handleprev = () => {
    previousPage()
    handlePageValue({
      pageSize: pageSize,
      pageNumber: pageIndex - 1,
    })
  }
  const handlestartpage = () => {
    gotoPage(0)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: 0,
    })
  }
  const handlelastpage = () => {
    gotoPage(pageCount - 1)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: Math.ceil(totalCount / pageSize) - 1,
    })
  }

  const onChangeInInput = event => {
    if (pageCount - 1 >= event.target.value) {
      const page = event.target.value > 0 ? Number(event.target.value) - 1 : 0

      //setpageValueSet(pageIndex +1)
      gotoPage(page)
      handlePageValue({
        pageSize: pageSize,
        pageNumber: page,
      })
    }
  }

  const getSelectedRowwValues = selectedRow => {
    if (hideAddUserbutton == true) {
      handleUserEditGroup({ ...selectedRow.original })
    }
    if (hideTrackProfilebutton == true) {
      handleTracEditGroup({ ...selectedRow.original })
    }
  }

  return (
    <Fragment>
      {buttonHide && hideAddUserbutton == true && (
        <Col className="userbutton ">
          <div className="d-flex justify-content-end ">
            <div>
              <button className="btn btn-primary me-2 " onClick={handleAddnewUser}>
                <i className="mdi mdi-plus me-1" />
                Add New User
              </button>
            </div>
            <button className="btn btn-primary" onClick={handlebulkUpload}>
              <i className="mdi mdi-plus me-1" />
              Add Bulk Upload
            </button>
          </div>
        </Col>

      )}
      <div className="table-responsive react-table ">
        <Table bordered hover {...getTableProps()}>
          <thead className="table-light table-center">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    onClick={() =>
                      accessGroup && onHeaderClick(column, pageSize, pageIndex)
                    }
                  >
                    <div
                      className={widthControl ? "mb-2 widthControl" : "mb-2"}
                      {...column.getSortByToggleProps()}
                    >
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                    <Filter column={column} />
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {(page.length > 0 &&
              page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr
                      style={{ cursor: "pointer" }}
                      {...row.getRowProps()}
                      onClick={e => {
                        {
                          (e.target.cellIndex || e.target.cellIndex === 0) &&
                            getSelectedRowwValues(row)
                        }
                      }}
                    >
                      {row.cells.map(cell => {
                        return (
                          <td
                            key={cell.id}
                            {...cell.getCellProps()}
                            data-label={cell?.column?.Header}
                          >
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  </Fragment>
                )
              })) || (
              <tr>
                <td
                  colSpan={colspanChange ? "18" : "6"}
                  className="react-bs-table-no-data p-5 text-center"
                >
                  Sorry, There are no data to display
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
              <div className="pagination justify-content-end customiz_pagination">
          {data.length > 0 && (
            <Col sm={customPageSizeOptions ? 2 : 2} className="me-3 p-2">
              <select
                className="form-select p-2"
                value={pageSize}
                onChange={onChangeInSelect}
              >
                {[10, 20, 30, 40, 50].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </Col>
          )}

          {!issetting && data.length > 0 && (
            // <div className="pagination justify-content-end align-items-center">
            <div className="paginations d-flex justify-content-end align-items-center">
              <Container>
                <Row className=" align-items-center">
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button
                        color="primary"
                        onClick={handlestartpage}
                        disabled={!canPreviousPage}
                      >
                        {"<<"}
                      </Button>{" "}
                      <Button
                        color="primary"
                        onClick={handleprev}
                        disabled={!canPreviousPage}
                      >
                        {"<"}
                      </Button>{" "}
                    </div>
                  </Col>
                  <Col className="col-md-auto d-none d-md-block">
                    <span>
                      Page{" "}
                      <strong>
                        {pageindex + 1} of {Math.ceil(totalCount / pageSize)}
                      </strong>{" "}
                    </span>
                  </Col>
                  <Col className="col-md-auto">
                    <span>
                      | Go to page:{" "}
                      <input
                        type="number"
                        value={pageindex + 1}
                        onChange={onChangeInInput}
                        style={{ width: "50px", textAlign: "center" }}
                      />
                    </span>
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button
                        color="primary"
                        onClick={handlenext}
                        disabled={
                          !canNextPage ||
                          pageIndex >= Math.ceil(totalCount / pageSize) - 1
                        }
                      >
                        {">"}
                      </Button>{" "}
                      <Button
                        color="primary"
                        onClick={handlelastpage}
                        disabled={
                          !canNextPage ||
                          pageIndex >= Math.ceil(totalCount / pageSize) - 1
                        }
                      >
                        {">>"}
                      </Button>{" "}
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          )}
        </div>
      
    </Fragment>
  )
}

ManageSettingsTableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default ManageSettingsTableContainer
